var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useScalprum } from '@scalprum/react-core';
import { useLocation } from 'react-router-dom';
import { ChromeContext } from '../ChromeContext';
import chromeState from './chromeState';
import { IDENTITY_URL, LAST_VISITED_URL, get, post } from '../utils/fetch';
var getUserIdentity = function () { return get(IDENTITY_URL); };
var useLastPageVisitedUploader = function (providerState) {
    var inactiveDuration = 1000 * 20;
    var batchUpdateInterval = 1000 * 60 * 3;
    var inactiveTimeout = useRef(undefined);
    var postBatchData = function (recentPages) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, post(LAST_VISITED_URL, {
                            pages: recentPages,
                        })];
                case 1:
                    _a.sent();
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Unable to update last visited pages!', error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var sanitizeRecentPages = function (recentPages) {
        return recentPages.map(function (_a) {
            var pathname = _a.pathname, title = _a.title, bundle = _a.bundle;
            return ({ pathname: pathname, title: title, bundle: bundle });
        });
    };
    var clearInactiveTimeout = function () {
        if (inactiveTimeout.current !== undefined) {
            clearTimeout(inactiveTimeout.current);
            inactiveTimeout.current = undefined;
        }
    };
    var updateMostRecentPages = function () { return __awaiter(void 0, void 0, void 0, function () {
        var recentPages, sanitizedPages;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    recentPages = providerState.getState().lastVisitedPages;
                    sanitizedPages = sanitizeRecentPages(recentPages);
                    return [4, postBatchData(sanitizedPages)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    useEffect(function () {
        var updateInterval = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                updateMostRecentPages();
                return [2];
            });
        }); }, batchUpdateInterval);
        var handleVisibilityChange = function () {
            if (document.visibilityState !== 'visible') {
                if (inactiveTimeout.current) {
                    return;
                }
                inactiveTimeout.current = setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        updateMostRecentPages();
                        return [2];
                    });
                }); }, inactiveDuration);
            }
            else {
                clearInactiveTimeout();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return function () {
            clearInterval(updateInterval);
            clearInactiveTimeout();
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
};
var LAST_VISITED_FLAG = 'chrome:lastVisited';
var useLastVisitedLocalStorage = function (providerState) {
    var pathname = useLocation().pathname;
    var scalprum = useScalprum();
    var titleTarget = document.querySelector('title');
    var getInitialPages = function () { return __awaiter(void 0, void 0, void 0, function () {
        var localVisited, firstPages, _a, error_2;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    localVisited = [];
                    try {
                        localVisited = JSON.parse((_b = localStorage.getItem(LAST_VISITED_FLAG)) !== null && _b !== void 0 ? _b : '[]');
                        if (!Array.isArray(localVisited)) {
                            localVisited = [];
                        }
                    }
                    catch (error) {
                        console.error('Unable to parse last visited pages from localStorage!', error);
                        localVisited = [];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    _a = [[]];
                    return [4, get(LAST_VISITED_URL)];
                case 2:
                    firstPages = __spreadArray.apply(void 0, [__spreadArray.apply(void 0, _a.concat([((_c = (_d.sent())) !== null && _c !== void 0 ? _c : []), true])), localVisited, true]).slice(0, 10);
                    providerState.setLastVisited(firstPages);
                    localStorage.setItem(LAST_VISITED_FLAG, JSON.stringify(firstPages));
                    return [3, 4];
                case 3:
                    error_2 = _d.sent();
                    console.error('Unable to load initial last visited pages!', error_2);
                    providerState.setLastVisited(localVisited);
                    localStorage.setItem(LAST_VISITED_FLAG, JSON.stringify(localVisited));
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    useEffect(function () {
        getInitialPages();
    }, []);
    useEffect(function () {
        var titleObserver;
        var prevTitle;
        if (titleTarget) {
            titleObserver = new MutationObserver(function (mutations) {
                var _a, _b;
                var currentTitle = (_a = mutations[0]) === null || _a === void 0 ? void 0 : _a.target.textContent;
                if (typeof currentTitle === 'string' && currentTitle !== prevTitle) {
                    try {
                        prevTitle = currentTitle;
                        var newTitles = providerState.getState().lastVisitedPages.filter(function (item) { return item.pathname !== pathname; });
                        newTitles.unshift({ pathname: pathname, title: currentTitle, bundle: (_b = scalprum.api) === null || _b === void 0 ? void 0 : _b.chrome.getBundleData().bundleTitle });
                        providerState.setLastVisited(newTitles.slice(0, 10));
                        localStorage.setItem(LAST_VISITED_FLAG, JSON.stringify(newTitles.slice(0, 10)));
                    }
                    catch (error) {
                        console.error('Unable to update last visited pages!', error);
                    }
                }
            });
            titleObserver.observe(titleTarget, {
                childList: true,
            });
        }
        return function () {
            titleObserver === null || titleObserver === void 0 ? void 0 : titleObserver.disconnect();
        };
    }, [pathname]);
};
var ChromeProvider = function (_a) {
    var children = _a.children;
    var isMounted = useRef(false);
    var _b = useState(false), initialRequest = _b[0], setInitialRequest = _b[1];
    var providerState = useRef();
    if (!providerState.current) {
        providerState.current = chromeState();
    }
    useLastVisitedLocalStorage(providerState.current);
    useLastPageVisitedUploader(providerState.current);
    useEffect(function () {
        isMounted.current = true;
        if (!initialRequest) {
            getUserIdentity()
                .then(function (identity) {
                var _a;
                if (isMounted.current) {
                    (_a = providerState.current) === null || _a === void 0 ? void 0 : _a.setIdentity(identity);
                    setInitialRequest(true);
                }
            })
                .catch(function (error) {
                console.error('Unable to initialize ChromeProvider!', error);
            });
        }
        return function () {
            isMounted.current = false;
        };
    }, []);
    return _jsx(ChromeContext.Provider, { value: providerState.current, children: children });
};
export default ChromeProvider;
//# sourceMappingURL=ChromeProvider.js.map